import React, { FC } from 'react';
import ICtaBox from '../../../interfaces/elements/ctaBox';
import { Column, Columns } from '../../base/grid';
import CtaBox from '../ctaBox';
import * as StyledCtaBoxColumns from './ctaBoxColumns.styles';

interface Props {
	boxes: ICtaBox[];
}

const CtaBoxColumns: FC<Props> = ({ boxes }) => {
	return (
		<StyledCtaBoxColumns.Wrapper>
			<Columns>
				{boxes.map((box, index) => (
					<Column mobile={1 / 2} tablet={1 / 4} key={index}>
						<CtaBox box={box} />
					</Column>
				))}
			</Columns>
		</StyledCtaBoxColumns.Wrapper>
	);
};

export default CtaBoxColumns;
